"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantProfileJobExperienceSkills = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const Api = __importStar(require("@src/api"));
const normalize_string_1 = require("@src/helpers/normalize-string");
const antd_1 = require("antd");
const debounce_1 = __importDefault(require("lodash/debounce"));
const elements_1 = require("@src/components/elements");
const SkillTagSelect_style_1 = require("@src/components/pages/profile/modules/resume/form/ApplicantProfileComponents/SkillTagSelect.style");
const ApplicantProfileExperience_style_1 = require("./ApplicantProfileExperience.style");
const ApplicantProfileJobExperienceSkills = ({ restField, fieldKey, jobExperienceIndex, form }) => {
    const [skillOptions, setSkillOptions] = react_1.default.useState([]);
    const [searchValue, setSearchValue] = react_1.default.useState('');
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const [selectedSkills, setSelectedSkills] = react_1.default.useState([]);
    const maxTagCount = 5;
    const maxTagTextLength = 30;
    const areSelectedSkillsOverLimit = selectedSkills.length >= maxTagCount;
    const areOptionsEmpty = skillOptions.length === 0;
    const shouldHideDropdown = (areOptionsEmpty && !searchValue) || areSelectedSkillsOverLimit;
    const onSearch = async (actualSelectedSkills, searchText) => {
        try {
            setIsLoading(true);
            const normalizedSearchedText = searchText ? (0, normalize_string_1.normalizeStr)(searchText) : undefined;
            if (!normalizedSearchedText) {
                setSkillOptions([]);
                return;
            }
            const { allSkillTags } = await Api.SkillTag.getAutoCompleteSkillTags(normalizedSearchedText, actualSelectedSkills);
            setSkillOptions(allSkillTags);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsLoading(false);
        }
    };
    const debounceOnSearch = react_1.default.useCallback((0, debounce_1.default)(onSearch, 300), []);
    const addExpression = async () => {
        try {
            const trimmedSearchValue = searchValue.trim();
            if (!trimmedSearchValue) {
                setSearchValue('');
                setSkillOptions([]);
                return;
            }
            const { skillTagToFind } = await Api.SkillTag.getSingleSkillTag(trimmedSearchValue);
            let newOption = { value: trimmedSearchValue, label: trimmedSearchValue, key: trimmedSearchValue };
            if (skillTagToFind) {
                const { name: tagName } = skillTagToFind;
                newOption = { value: tagName, label: tagName, key: tagName };
            }
            const isTagAlreadySelected = Boolean(selectedSkills.find(({ value }) => (0, normalize_string_1.normalizeStr)(value) === (0, normalize_string_1.normalizeStr)(newOption.value)));
            setSearchValue('');
            setSkillOptions([]);
            if (isTagAlreadySelected) {
                antd_1.notification.warning({
                    message: intl.formatMessage({
                        id: 'general.warning',
                    }),
                    description: intl.formatMessage({
                        id: 'profile.resume.skill.duplicate_skill_warning',
                    }),
                });
                return;
            }
            const newSelectedSkills = [...(selectedSkills || []), newOption];
            setSelectedSkills(newSelectedSkills);
            form.setFields([
                {
                    name: ['jobExperience', jobExperienceIndex, 'skillsUsed'],
                    value: newSelectedSkills,
                },
            ]);
        }
        catch (err) {
            console.error(err);
        }
    };
    react_1.default.useEffect(() => {
        const selectedOptions = form.getFieldValue(['jobExperience', jobExperienceIndex, 'skillsUsed']);
        setSelectedSkills(selectedOptions || []);
    }, []);
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(ApplicantProfileExperience_style_1.SkillSelectFormItemWrapper, { ...restField, name: [jobExperienceIndex, 'skillsUsed'], fieldKey: [fieldKey, 'skillsUsed'], label: intl.formatMessage({
            id: 'profile.resume.skills_used',
        }), tooltip: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.skills_used_tooltip" }), children: (0, jsx_runtime_1.jsx)(elements_1.Select, { mode: "multiple", labelInValue: true, dropdownClassName: shouldHideDropdown ? 'hidden' : '', placeholder: intl.formatMessage({ id: 'profile.resume.skills_used_placeholder' }), onSearch: inputTextValue => {
                let inputText = inputTextValue;
                const isInputTooLong = inputText.length > maxTagTextLength;
                if (inputText === ',') {
                    return;
                }
                if (inputTextValue[inputTextValue.length - 1] === ',') {
                    addExpression();
                }
                if (inputText.includes(',')) {
                    inputText = inputText.substring(0, inputText.indexOf(','));
                }
                if (isInputTooLong) {
                    inputText = inputText.substring(0, maxTagTextLength);
                }
                if (!areSelectedSkillsOverLimit) {
                    setSearchValue(inputText);
                    debounceOnSearch(selectedSkills, inputText);
                }
            }, searchValue: searchValue, filterOption: false, onSelect: option => {
                const newSelectedItems = [...(selectedSkills || []), option];
                setSearchValue('');
                setSkillOptions([]);
                setSelectedSkills(newSelectedItems);
            }, onDeselect: ({ value: optionValue }) => {
                const newSelectedItems = selectedSkills.filter(({ value }) => value !== optionValue);
                setSelectedSkills(newSelectedItems);
            }, loading: isLoading, onFocus: () => setSearchValue(''), options: skillOptions, dropdownRender: menu => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [searchValue && ((0, jsx_runtime_1.jsx)(ApplicantProfileExperience_style_1.AddExpressionButton, { type: "text", size: "middle", className: "p-b-xs p-t-xs p-l-s p-r-s flex-row align-center", icon: (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, { className: "m-r-s" }), onClick: () => {
                            addExpression();
                            setSearchValue('');
                        }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.tag_add_expression" }) })), !areOptionsEmpty && !isLoading && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: menu }), isLoading && (0, jsx_runtime_1.jsx)(SkillTagSelect_style_1.SpinnerWrapper, { size: "large", delay: 200 })] })) }) }));
};
exports.ApplicantProfileJobExperienceSkills = ApplicantProfileJobExperienceSkills;
